// src/index.js
import './services/pwaInstaller';
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { CookieConsentProvider } from './contexts/CookieConsentContext';
import { GoogleOAuthProvider } from '@react-oauth/google';

// --- 1. IMPORTY POSTHOG (NOWOŚĆ) ---
import posthog from 'posthog-js';
import { PostHogProvider } from 'posthog-js/react';

// --- 2. IMPORTY SENTRY ---
import * as Sentry from "@sentry/capacitor";
import * as SentryReact from "@sentry/react";

import App from "./App";
import { sentryBeforeSend, posthogSanitizeProperties } from './utils/privacyScrub';

const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
const CURRENT_ENV = process.env.REACT_APP_ENV || 'prod';

// --- 3. INICJALIZACJA POSTHOGA ---
// Odpalamy silnik analityczny. 
// UWAGA: On tutaj tylko się ładuje. Decyzję "czy nagrywać" podejmuje Twój CookieConsentContext.
posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_POSTHOG_HOST || 'https://eu.i.posthog.com',
    
    // WAŻNE: 'localStorage' jest stabilniejsze dla Capacitora niż cookies
    persistence: 'localStorage', 
    
    // Autocapture: Zbieranie kliknięć i zmian inputów z automatu
    autocapture: true,

    // SCRUBBING PII: usuwa e-maile/hasła/tokeny z properties KAŻDEGO zdarzenia
    // (chroni m.in. autocapture na ekranach logowania/rejestracji).
    sanitize_properties: posthogSanitizeProperties,

    // MASKOWANIE (Bezpieczeństwo danych wrażliwych na nagraniach)
    session_recording: {
        maskAllInputs: true, // Zamienia wpisywany tekst na gwiazdki
    },

    // Zabezpieczenie przed śmieceniem na localhost
    // loaded: (posthog) => {
    //     if (process.env.NODE_ENV === 'development') {
    //          console.log('PostHog loaded in DEV mode (Events may be captured if consent is forced)');
    //     }
    // }
});

// --- 4. INICJALIZACJA SENTRY ---
Sentry.init({
  dsn: SENTRY_DSN,
  dist: "1",
  environment: CURRENT_ENV,
  
  integrations: [
    SentryReact.browserTracingIntegration(),
    // STRATEGICZNA ZMIANA: Wyłączamy Replay w Sentry.
    // Masz to teraz w PostHogu. Nie dubluj, bo zabijesz wydajność apki.
    // SentryReact.replayIntegration(), 
  ],

  enableNative: true, // Łapie błędy Java/Swift w Capacitorze

  // RODO: nie dołączaj domyślnie PII (IP, dane usera) do błędów.
  sendDefaultPii: false,

  // Scrubbing PII z każdego zdarzenia (message/request/extra/breadcrumbs/user).
  beforeSend: sentryBeforeSend,

  // Performance Monitoring (próbkowanie obniżone — 100% było drogie i zbędne na prodzie)
  tracesSampleRate: 0.2,

  // Session Replay (WYŁĄCZAMY W SENTRY - przejął to PostHog)
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1,
}, SentryReact.init);


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SentryReact.ErrorBoundary fallback={<div style={{ padding: 20 }}>Wystąpił nieoczekiwany błąd. Przepraszamy za utrudnienia.</div>}>
      
      {/* --- 5. WRAPPER POSTHOG (Musi otaczać App) --- */}
      <PostHogProvider client={posthog}>
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
            {/* CookieConsentProvider zarządza włączaniem/wyłączaniem PostHoga w zależności od zgody */}
            <CookieConsentProvider>
                <App />
            </CookieConsentProvider>
        </GoogleOAuthProvider>
      </PostHogProvider>

    </SentryReact.ErrorBoundary>
  </React.StrictMode>
);

// --- Rejestracja Service Workera ---
if ('serviceWorker' in navigator && 'PushManager' in window) {
  window.addEventListener('load', () => {
    const swUrl = `/service-worker.js`;
    navigator.serviceWorker.register(swUrl)
      .then(registration => {
        console.log('Service Worker zarejestrowany pomyślnie, zakres:', registration.scope);
      })
      .catch(error => {
        console.error('Błąd podczas rejestracji Service Workera:', error);
      });
  });
} else {
  console.warn('Powiadomienia push lub Service Worker nie są wspierane przez tę przeglądarkę.');
}